<template>
    <div class="row" style="position: relative;">
        <div style="background-color: white;border-radius: 6px;width: 100%;"
             v-bind:class="{ mainright: showRight }">
            <div class="top-bar">
                <div class="tpl-portlet-title" style="border-bottom: 1px solid rgb(215, 216, 217)">
                    <div class="left">
                        <a href="javascript:;" style="padding: 7px;position: absolute; left: 4%;top: 10px;font-size: 14px;"
                             @click="$router.go(-1)">
                            <i class="el-icon-arrow-left">返回</i>
                        </a>
                        <el-button size="mini" style="padding: 7px;position: absolute; right: 4%;top: 10px;"
                                   type="primary"
                                   @click="save()">立即保存
                        </el-button>
                    </div>
                </div>
                <div>
                    <div style="border-bottom: 1px solid #d7d8d9">
                        <span style="color:#7e8b9a;margin-right: 10px;">类型</span>
                        <el-select v-model="plan_Type" placeholder="请选择计划类型" style="width: 85%;text-align: center">
                            <el-option
                                    v-for="item in plan_type_options"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                            </el-option>
                        </el-select>
                    </div>
                    <div style="border-bottom: 1px solid #d7d8d9">
                        <span style="color:#7e8b9a;margin-right: 10px;">日期</span>
                        <div v-if="plan_Type === 'week'" id="week-plan">
                            <WeekPicker :endDate="endDate" :startDate="startDate" :weekValue="dateValue"
                                        style="width: 130px;" @change="pickTime" @fuc="getDate"></WeekPicker>
                        </div>
                        <div v-else-if="plan_Type === 'month'" id="month-plan">
                            <el-date-picker
                                    v-model="dateValue"
                                    :editable="false"
                                    placeholder="选择月"
                                    style="width: 130px !important;height: 40px;"
                                    type="month"
                                    value-format="yyyy-MM-dd"
                                    @change="pickTime">
                            </el-date-picker>
                        </div>
                        <div v-else-if="plan_Type === 'quarter'" id="quarter-plan">
                            <QuarterPicker :defaultValue="dateValue" @change="pickTime" @fuc="getDate"></QuarterPicker>
                        </div>
                        <div v-else-if="plan_Type === 'custom'" id="custom-plan"
                             class="new-custom-plan" style="height: 40px;line-height: 40px;display: inline;">
                            <el-date-picker v-model="startDate"
                                            :clearable="false"
                                            :editable="false"
                                            :picker-options="limitDateStart()"
                                            placeholder="开始日期"
                                            size="mini"
                                            style="width: 130px;height: 40px;"
                                            type="date"
                                            value-format="yyyy-MM-dd">
                            </el-date-picker>
                            <span>至</span>
                            <el-date-picker v-model="endDate"
                                            :clearable="false"
                                            :editable="false"
                                            :picker-options="limitDateEnd()"
                                            placeholder="截止日期"
                                            size="mini"
                                            style="width: 130px;height: 40px;margin-left: 5px;"
                                            type="date"
                                            value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </div>
                    </div>
                    <div style="border-bottom: 1px solid #d7d8d9">
                        <span style="color:#7e8b9a;">标题</span>
                        <input id="planTitle" v-model="title" class="plan-title" maxlength="45"
                               placeholder="计划标题"
                               style=" height: 40px;width: 85%;margin-left: 15px;line-height: 40px;" type="text"
                               value="">
                    </div>
                    <div style="border-bottom: 1px solid #d7d8d9;position: relative">
                        <span style="color:#7e8b9a;top:10px;position: absolute">内容</span>
                        <textarea v-model="content"
                                  placeholder="主要工作内容"
                                  style="height: 65px;width:85%;padding: 9px;border:none;margin-left: 35px;"></textarea>

                    </div>
                    <div style="border-bottom: 1px solid #d7d8d9;position: relative">
                        <span style="color:#7e8b9a;position: relative;top:10px;">细则    <span class="text-blue" @click="addRuleData()">+添加</span></span>
                                              <div style="clear: both;"></div>
                        <div class="plan-content-wrap" style="margin-top: 20px;">
                            <div class="plan-content">

                                <div class="plan-detail-box ui-sortable ui-sortable-disabled">

                                    <div class="plan-detail-wrap">
                                        <div v-for='(item,index) in lists' :key="index"
                                             class="plan-detail"
                                             style="position: relative;margin-bottom: 5px;">
                                            <div style="float:left;width: 60%;margin-bottom: 10px;">
                                                <textarea
                                                        v-model="item.content"
                                                        class="planDetail rule-index"
                                                        data-value="item.content"
                                                        placeholder="计划细则"
                                                        style="height: 60px;width: 100%;float: left;padding: 5px;border-radius: 6px;min-height: 60px;"></textarea>
                                            </div>
                                            <div style="float:left;width: 40%;">
                                                <div style="margin: 5px 0">
                                                    <input v-model="item.isImportant" style="margin-left: 11px"
                                                           type="checkbox"/>
                                                    <span style="margin: 0 20% 0 3%;">重要</span>
                                                    <i v-if="item.plan_id === true" class="el-icon-delete-solid"
                                                       title="删除该计划细则"
                                                       v-on:click='lists.splice(index, 1)'></i>
                                                    <el-popover v-else
                                                                content="该细则无法被删除"
                                                                placement="top"
                                                                trigger="click"
                                                                width="100">
                                                        <i slot="reference" class="el-icon-info"></i>
                                                    </el-popover>
                                                </div>
                                                <div style="margin-top: 5px;">
                                                    <el-date-picker v-model="item.rDate"
                                                                    :clearable="false"
                                                                    :editable="false"
                                                                    :picker-options="limitDateStart(item)"
                                                                    class="detailDate"
                                                                    format="MM-dd"
                                                                    placeholder="开始"
                                                                    style="float: left;width: 55px !important;"
                                                                    type="date"
                                                                    value-format="yyyy-MM-dd">
                                                    </el-date-picker>
                                                    <span style="width: 10%;position:relative;left: 15px;"> ~ </span>
                                                    <el-date-picker v-model="item.eDate"
                                                                    :clearable="false"
                                                                    :editable="false"
                                                                    :picker-options="limitDateEnd(item)"
                                                                    class="detailDate detail-end-Date"
                                                                    format="MM-dd"
                                                                    placeholder="截止"
                                                                    style="position: relative;left: 15px;width: 40px !important;"
                                                                    type="date"
                                                                    value-format="yyyy-MM-dd">
                                                    </el-date-picker>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                               <div class="plan-detail-wrap">
                                    <p style="font-weight: bold;"><i class="fa fa-tasks"></i> 其他细则  <span style="font-weight: bold;">{{other_plan_details.length}}</span> </p>

                                        <div v-for='(item,index) in other_plan_details'
                                             v-if="other_plan_details.length > 0"
                                             :key="index"
                                             class="plan-detail"
                                             style="position: relative;margin-bottom: 5px;">
                                            <div style="float:left;width: 60%;margin-bottom: 10px;">
                                                <textarea
                                                        v-model="item.content"
                                                        class="planDetail rule-index"
                                                        data-value="item.content"
                                                        placeholder="计划细则"
                                                        style="height: 60px;width: 100%;float: left;padding: 5px;border-radius: 6px;min-height: 60px;"></textarea>
                                            </div>
                                            <div style="float:left;width: 40%;">
                                                <div style="margin: 5px 0">
                                                    <input v-model="item.isImportant" style="margin-left: 11px"
                                                           type="checkbox"/>
                                                    <span style="margin: 0 20% 0 3%;">重要</span>
                                                    <i v-if="item.plan_id === true" class="el-icon-delete-solid"
                                                       title="删除该计划细则"
                                                       v-on:click='lists.splice(index, 1)'></i>
                                                    <el-popover v-else
                                                                content="该细则无法被删除"
                                                                placement="top"
                                                                trigger="click"
                                                                width="100">
                                                        <i slot="reference" class="el-icon-info"></i>
                                                    </el-popover>
                                                </div>
                                                <div style="margin-top: 5px;">
                                                    <el-date-picker v-model="item.rDate"
                                                                    :clearable="false"
                                                                    :editable="false"
                                                                    :picker-options="limitDateStart(item)"
                                                                    class="detailDate"
                                                                    format="MM-dd"
                                                                    placeholder="开始"
                                                                    style="float: left;width: 55px !important;"
                                                                    type="date"
                                                                    value-format="yyyy-MM-dd">
                                                    </el-date-picker>
                                                    <span style="width: 10%;position:relative;left: 15px;"> ~ </span>
                                                    <el-date-picker v-model="item.eDate"
                                                                    :clearable="false"
                                                                    :editable="false"
                                                                    :picker-options="limitDateEnd(item)"
                                                                    class="detailDate detail-end-Date"
                                                                    format="MM-dd"
                                                                    placeholder="截止"
                                                                    style="position: relative;left: 15px;width: 40px !important;"
                                                                    type="date"
                                                                    value-format="yyyy-MM-dd">
                                                    </el-date-picker>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div style="clear: both;"></div>
                            </div>
                        </div>
                        <div class="add-category" style="display: none;"><i class="icon-add-category"></i><span>+继续添加计划内容</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showRight" class="previewBox">
            <RightPlanView :dateValue="dateValue" :plan_Type="plan_Type" @close="clickClose()"></RightPlanView>
        </div>
    </div>
</template>

<script>
import QuarterPicker from '@/components/common_components/datepicker/quarter_picker.vue'
import WeekPicker from '@/components/common_components/datepicker/week_picker.vue'
import RightPlanView from '@/apps/plan/sub_components/right_plan_view.vue'
import planApi from '@/api/plan/plan_api.js'
import {mapActions, mapGetters, mapState} from 'vuex'

export default {
    name: "new_plan",
    props: {
        prev_plan: {
            default: null,
            type: Object
        }
    },
    data: function () {
        return {
            showRight: false,
            quarterArray: ["01", "04", "07", "10"],
            quarterArray2: [1, 4, 7, 10],
            title: '',
            content: '',
            summary: '',
            plan_Type: this.$route.params.planType,
            dateValue: this.$route.params.dateValue,
            startDate: this.$route.params.startDate,
            endDate: this.$route.params.endDate,
            weekIdex: this.$route.params.weekIdex,
            value1: '',
            lists: [{
                idx:1,
                id: 0,
                plan_id: true,
                content: '',
                rDate: '',
                eDate: '',
                isImportant: false,
                isEmergency: false,
                isDelete: false,
            }],
            other_plan_details: [],
            nextTodoId: 2,
            plan_type_options: [{
                value: 'week',
                label: '周计划'
            }, {
                value: 'month',
                label: '月计划'
            }, {
                value: 'quarter',
                label: '季计划'
            }, {
                value: 'custom',
                label: '自定义'
            }],
        }
    },
    computed: {
        ...mapState({
            my_plans: state => state.plan.my_plans,
            active_planType: state => state.plan.active_plan_type,
            new_plan_startDate: state => state.plan.new_plan_startDate,
            new_plan_endDate: state => state.plan.new_plan_endDate,
        }),
        ...mapGetters({}),
    },
    watch: {
        plan_Type: function (value, oldValue) {
            const currDate = new Date();
            let get_other_detail = false;
            if (value === 'quarter') {
                get_other_detail = true;
                let month = currDate.getMonth() + 1;
                let no_zero_month = 1;
                if (1 <= month && month <= 3) {
                    month = '01';
                    no_zero_month = 1;
                } else if (4 <= month && month <= 6) {
                    month = '04';
                    no_zero_month = 4;
                } else if (7 <= month && month <= 10) {
                    month = '07';
                    no_zero_month = 7;
                } else {
                    month = '10';
                    no_zero_month = 10;
                }
                this.dateValue = this.startDate = currDate.getFullYear() + '-' + no_zero_month + '-01';
                this.endDate = currDate.getFullYear() + '-' + (no_zero_month + 2) + '-' + new Date(currDate.getFullYear(), (no_zero_month + 2), 0).getDate();
                this.title = currDate.getFullYear() + '年' + (this.quarterArray.indexOf(month) + 1) + '季度计划';
            } else if (value === 'month') {
                get_other_detail = true;
                this.dateValue = this.startDate = currDate.getFullYear() + '-' + (currDate.getMonth() + 1) + '-01';
                this.endDate = currDate.getFullYear() + '-' + (currDate.getMonth() + 1) + '-' + new Date(currDate.getFullYear(), (currDate.getMonth() + 1), 0).getDate();
                this.title = currDate.getFullYear() + '年' + (currDate.getMonth() + 1) + '月计划';
            } else if (value === 'week') {
                get_other_detail = true;
                this.dateValue = '';
                this.title = currDate.getFullYear() + '年第' + this.weekIdex + '周计划';
                let mondayString = this.GetMonday(currDate)
                this.dateValue = mondayString
                this.startDate = mondayString
                let d = new Date(mondayString)
                d.setMilliseconds(d.getMilliseconds() + (6 * 24 * 60 * 60 * 1000))
                this.endDate = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
            } else {
                this.title = '';
                this.endDate = '';
            }

            this.other_plan_details = [];
            const autoDate = this.autoSelectDate();
            for (let i = 0; i < this.lists.length; i++) {
                this.lists[i].rDate = autoDate[0];
                this.lists[i].eDate = autoDate[1];
            }

            if (get_other_detail === false) return;
            let args = {
                'sdate': this.startDate,
                'edate': this.endDate,
                'ptype': this.plan_Type,
            }
            planApi.get_my_todos_by_date(args).then(res => {
                res.data.sort(function (a, b) {
                    if (a.plan_id === b.plan_id) return a.id - b.id;
                    else return a.plan_id - b.plan_id;
                }).forEach((item) => {
                    this.other_plan_details.push({
                        id: item.id,
                        plan_id: item.plan_id,
                        content: item.details,
                        rDate: item.start_time,
                        eDate: item.end_time,
                        isImportant: item.isImportant,
                        isEmergency: item.isEmergency,
                        isDelete: item.isDelete,
                    });
                });
            });
            this.pickTime(this.startDate);
        },
        dateValue: async function (value, oldValue) {
            if (value) {
                let myDate = new Date(value);
                if (this.plan_Type === 'week') {
                    this.title = myDate.getFullYear() + '年第' + this.weekIdex + '周计划'
                }
                if (this.plan_Type === 'month') {
                    this.title = myDate.getFullYear() + '年' + (myDate.getMonth() + 1) + '月计划';
                }
                if (this.plan_Type === 'quarter') {
                    let arr = value.split('-')
                    let str = arr[1]
                    str = parseInt(str) < 10 ? ('0' + parseInt(str)) : str
                    this.title = myDate.getFullYear() + '年' + (this.quarterArray.indexOf(str) + 1) + '季度计划'
                }
                if (this.plan_Type === 'custom') {
                    const sDate = value[0].getFullYear() + '/' + (value[0].getMonth() + 1) + '/' + value[0].getDate();
                    const eDate = value[1].getFullYear() + '/' + (value[1].getMonth() + 1) + '/' + value[1].getDate();
                    this.title = '自定义计划(' + sDate + ' - ' + eDate + ')';
                }
            }
            this.showRight = false
        },
    },
    methods: {
        ...mapActions({
            get_my_plans: 'plan/get_my_plans',
            change_active_plan_type: 'plan/change_active_plan_type',
            change_new_plan_startDate: 'plan/change_new_plan_startDate',
            change_new_plan_endDate: 'plan/change_new_plan_endDate',
            change_warning_message: 'warningBar/change_message',
            change_warning_bar_style_class: 'warningBar/change_warning_bar_style_class'
        }),
        set_active_plan_type: function () {
            this.change_active_plan_type(this.plan_Type)
            this.showRight = false
        },
        pickTime(pickDate) {
            let p = []
            let emptyMsg = ''
            let newDate = new Date(pickDate);
            for (var i = 0; i < this.my_plans.length; i++) {
                if (this.plan_Type === 'month') {
                    if (this.my_plans[i].plan_type === "month" && (new Date(this.my_plans[i].open_time)).getFullYear() == newDate.getFullYear() && ((new Date(this.my_plans[i].open_time)).getMonth() + 1) == (newDate.getMonth() + 1)) {
                        p.push(this.my_plans[i]);
                        emptyMsg = newDate.getFullYear() + '年' + (newDate.getMonth() + 1) + '月已创建计划内容';
                        break
                    }
                    this.startDate = pickDate;
                }
                if (this.plan_Type === 'week') {
                    if (this.my_plans[i].plan_type === "week" && (new Date(this.my_plans[i].open_time)).getFullYear() == newDate.getFullYear() && (new Date(this.my_plans[i].open_time)).getMonth() == newDate.getMonth() && (new Date(this.my_plans[i].open_time)).getDate() == newDate.getDate()) {
                        p.push(this.my_plans[i]);
                        emptyMsg = newDate.getFullYear() + '年第' + this.getWeek(newDate) + '周已创建计划内容';
                        break
                    }
                    this.startDate = pickDate;
                }
                if (this.plan_Type === 'quarter') {
                    if (this.my_plans[i].plan_type === "quarter" && (new Date(this.my_plans[i].open_time)).getFullYear() == newDate.getFullYear() && ((new Date(this.my_plans[i].open_time)).getMonth() + 1) == (newDate.getMonth() + 1)) {
                        p.push(this.my_plans[i]);
                        emptyMsg = newDate.getFullYear() + '年第' + (this.quarterArray2.indexOf((newDate.getMonth() + 1)) + 1) + '季度已创建计划内容';
                        break
                    }
                    this.startDate = pickDate;
                }
                if (this.plan_Type === 'custom') {
                    const newDate1 = this.startDate;
                    const newDate2 = newDate;
                    const currPlanOpenTime = new Date(this.my_plans[i].open_time);
                    const currPlanEndTime = new Date(this.my_plans[i].end_time);
                    // this.startDate = newDate1.getFullYear() + '-' + (newDate1.getMonth() + 1) + '-' + newDate1.getDate();
                    // this.endDate = newDate2.getFullYear() + '-' + (newDate2.getMonth() + 1) + '-' + newDate2.getDate();
                    if (this.my_plans[i].plan_type === "custom" && currPlanOpenTime.getFullYear() === newDate1.getFullYear() && currPlanOpenTime.getMonth() === newDate1.getMonth() && currPlanOpenTime.getDate() === newDate1.getDate()
                        && currPlanEndTime.getFullYear() === newDate2.getFullYear() && currPlanEndTime.getMonth() === newDate2.getMonth() && currPlanEndTime.getDate() === newDate2.getDate()) {
                        p.push(this.my_plans[i]);
                        emptyMsg = '自定义计划(' + this.startDate + ' - ' + this.endDate + ')已创建计划内容';
                        break
                    } else {
                        const sDate = newDate1.getFullYear() + '/' + (newDate1.getMonth() + 1) + '/' + newDate1.getDate();
                        const eDate = newDate2.getFullYear() + '/' + (newDate2.getMonth() + 1) + '/' + newDate2.getDate();
                        this.title = '自定义计划(' + sDate + ' - ' + eDate + ')';
                    }
                }
            }
            const autoDate = this.autoSelectDate();
            for (let i = 0; i < this.lists.length; i++) {
                this.lists[i].rDate = autoDate[0];
                this.lists[i].eDate = autoDate[1];
            }
            if (p.length > 0) {
                this.dateValue = null
                this.title = null
                this.change_warning_message(emptyMsg);
                this.change_warning_bar_style_class('alert');
            }
        },
        getDate: function (val, val2, val3) {
            this.dateValue = val;
            this.startDate = val;
            this.endDate = val2;
            this.weekIdex = val3;

            const autoDate = this.autoSelectDate();
            for (let i = 0; i < this.lists.length; i++) {
                this.lists[i].rDate = autoDate[0];
                this.lists[i].eDate = autoDate[1];
            }

            let myDate = new Date(this.startDate.toString());
            if (this.plan_Type === 'week') {
                this.title = myDate.getFullYear() + '年第' + this.weekIdex + '周计划';
            }
        },
        addRule: function (date) {
            this.lists.push({
                idx:this.nextTodoId++,
                id: 0,
                plan_id: true,
                content: '',
                rDate: date[0],
                eDate: date[1],
                isImportant: false,
                isEmergency: false,
                isDelete: false,
            })
        },
        addRuleData: function () {
            const autoDate = this.autoSelectDate();
            this.addRule(autoDate);
        },
        addDays: function (d, planType) {
            let date = new Date(d);
            return planType === 'month' ? (date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + (new Date(date.getFullYear(), date.getMonth() + 1, 0)).getDate()) : date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + (date.getDate() + 5);
        },
        autoSelectDate: function () {
            let tempStartDate = '';
            let tempEndDate = '';
            if (this.plan_Type === 'week' || this.plan_Type === 'custom') {
                tempStartDate = this.startDate;
                tempEndDate = this.endDate;
            } else if (this.plan_Type === 'month') {
                const currDate = new Date(this.startDate.toString());
                const year = currDate.getFullYear();
                const month = currDate.getMonth() + 1;
                tempStartDate = year + '-' + month + '-1';
                tempEndDate = year + '-' + month + '-' + new Date(year, month, 0).getDate();
            } else if (this.plan_Type === 'quarter') {
                const eDateArray = this.dateValue.replace(/\//g, '-').split('-');
                const month = parseInt(eDateArray[1]) + 2;
                tempStartDate = eDateArray[0] + '-' + eDateArray[1] + '-1';
                tempEndDate = eDateArray[0] + '-' + month + '-' + new Date(eDateArray[0], month, 0).getDate();
            }
            if (tempStartDate && tempStartDate !== 'undefined') tempStartDate = tempStartDate.replace(/\//g, '-');
            if (tempEndDate && tempEndDate !== 'undefined') tempEndDate = tempEndDate.replace(/\//g, '-');
            else tempEndDate = '';
            return [tempStartDate, tempEndDate];
        },
        save: async function () {
            let saveMsg = '';
            let result = 'success';
            let number = '';
            if (this.plan_Type === 'month') {
                let arr = this.dateValue.split("-");
                this.startDate = arr[0] + '-' + arr[1] + '-01';
                this.endDate = this.addDays(this.startDate, 'month');
            } else if (this.plan_Type === 'custom') {
                this.startDate = this.startDate.getFullYear() + '-' + (this.startDate.getMonth() + 1) + '-' + this.startDate.getDate();
            }

            this.startDate = this.startDate.replace(/\//g, '-');
            this.endDate = this.endDate.replace(/\//g, '-');

            if (!this.dateValue) {
                saveMsg = '计划日期不能为空'
                result = 'error'
            } else if (!this.title.trim()) {
                saveMsg = '标题不能为空'
                result = 'error'
            } else {
                let detailList = []
                for (let i = 0; i < this.lists.length; i++) {
                    if (this.lists[i].content.trim()) {
                        detailList.push(this.lists[i])
                    }
                }
                let res = await planApi.publish_plan({
                    title: this.title,
                    content: this.content,
                    summary: this.summary,
                    planType: this.plan_Type,
                    openTime: this.startDate,
                    endTime: this.endDate,
                    lists: [].concat(detailList).concat(this.other_plan_details),
                })
                let data = JSON.parse(res.data.result);
                result = data.code;
                saveMsg = data.message;
                number = data.plan.id;
            }
            this.change_warning_message(saveMsg);
            if (result === 'success') {
                this.change_warning_bar_style_class('success');
                await this.$router.go(-1);
            } else {
                this.change_warning_bar_style_class('alert');
            }
        },
        showPreviewPlan() {
            this.showRight = true;
            return;
        },
        limitDateStart: function (detail) {
            let other_date = this.endDate;
            if (detail != null) other_date = detail.eDate;
            return {
                disabledDate(time) {
                    return time.getTime() > new Date(other_date).getTime();
                }
            }
        },
        limitDateEnd: function (detail) {
            let other_date = this.startDate;
            if (detail != null) other_date = detail.rDate
            return {
                disabledDate(time) {
                    return time.getTime() < new Date(other_date).getTime();
                }
            }
        },
        clickClose() {
            this.showRight = false;
        },
        getWeek: function (z) {//参数z是"2018-05-07 15:12:36"或者"2018/05/07 15:12:36"
            let day11 = new Date(z);
            day11.setMonth(0);
            day11.setDate(1);
            day11.setHours(0);
            day11.setMinutes(0);
            day11.setSeconds(0);//到这里就得到该年的一月一日

            let day11mill = day11.getTime();
            let ori_day = day11.getDay();//该年的一月一日是星期几
            let fill1 = 0;//与星期日相隔的毫秒数
            if (ori_day !== 0) {
                fill1 = ori_day * 60 * 60 * 24 * 1000;
            }

            let now = Date.parse(z);
            now = new Date(now);
            now.setHours(0);
            now.setMinutes(0);
            now.setSeconds(0);
            let nowmill = now.getTime();
            let now_day = now.getDay();
            let fill2 = 0;
            if (now_day !== 0) {
                fill2 = (7 - now_day) * 60 * 60 * 24 * 1000;
            }

            let cha2 = (nowmill - day11mill + fill1 + fill2) / (60 * 60 * 24 * 1000);
            let week = Math.ceil(cha2 / 7);
            if (week < 10) {
                week = "0" + week;
            }
            return week;
        },
        GetMonday(dd) {
            let week = dd.getDay();
            let minus = week ? week - 1 : 6;
            dd.setDate(dd.getDate() - minus);
            let y = dd.getFullYear();
            let m = dd.getMonth() + 1;
            let d = dd.getDate();
            console.log('yymmmm' + y + "-" + m + "-" + d)
            return y + "-" + m + "-" + d;
        }
    },
    async mounted() {
        this.get_my_plans()
        this.lists = []
        if (typeof (this.plan_Type) != "undefined")
            this.change_active_plan_type(this.plan_Type)
        else this.plan_Type = this.active_planType
        if (typeof (this.startDate) != "undefined")
            this.change_new_plan_startDate(this.startDate)
        else this.startDate = this.new_plan_startDate

        if (typeof (this.endDate) != "undefined")
            this.change_new_plan_endDate(this.endDate)
        else this.endDate = this.new_plan_endDate
        this.dateValue = this.startDate;
        let myDate = new Date(this.startDate.toString());
        const autoDate = this.autoSelectDate();
        if (this.plan_Type === 'week') {
            this.title = myDate.getFullYear() + '年第' + this.weekIdex + '周计划';
            for (let kk = 0; kk < 5; kk++) {
                this.addRule(autoDate);
            }
        }
        if (this.plan_Type === 'month') {
            this.title = myDate.getFullYear() + '年' + (myDate.getMonth() + 1) + '月计划';
            for (let kk = 0; kk < 4; kk++) {
                this.addRule(autoDate);
            }
        }
        if (this.plan_Type === 'quarter') {
            let arr = this.startDate.split('-')
            let str = arr[1]
            str = parseInt(str) < 10 ? ('0' + parseInt(str)) : str
            this.title = myDate.getFullYear() + '年' + (this.quarterArray.indexOf(str) + 1) + '季度计划'
            for (let kk = 0; kk < 3; kk++) {
                this.addRule(autoDate);
            }
        }

        let args = {
            'sdate': this.startDate,
            'edate': this.endDate,
            'ptype': this.plan_Type,
        }
        let d = await planApi.get_my_todos_by_date(args);
        d.data.sort(function (a, b) {
                if (a.plan_id === b.plan_id) return a.id - b.id;
                else return a.plan_id - b.plan_id;
            }).forEach((item) => {
                this.other_plan_details.push({
                    id: item.id,
                    plan_id: item.plan_id,
                    content: item.details,
                    rDate: item.start_time,
                    eDate: item.end_time,
                    isImportant: item.isImportant,
                    isEmergency: item.isEmergency,
                    isDelete: item.isDelete,
                });
            });
    },
    components: {
        QuarterPicker,
        WeekPicker,
        RightPlanView
    },
}
</script>

<style scoped>
.top-bar {
    position: relative;
    padding: 5px 10px;
    overflow: hidden;
}
.plan-detail{
    overflow: hidden;
}
[class^="icon-"] {
    background-image: url(/static/img/plan.png?v=6);
    background-image: -webkit-image-set(url(/static/img/plan.png?v=6) 1x, url(/static/img/plan@2x.png?v=6) 2x);
    background-image: image-set(url(/static/img/plan.png?v=6) 1x, url(/static/img/plan@2x.png?v=6) 2x);
    vertical-align: middle;
    display: inline-block;
    background-repeat: no-repeat;
}

.new-main {
    padding-left: 24px;
    overflow: auto;
    z-index: -1 \0;
}


.new-main table {
    border-collapse: separate;
    border-spacing: 0 16px;
}

.must-fill {
    font-style: normal;
    color: #f00;
}

.new-main table td.even {
    padding-left: 4px;
}

.new-main table td input[type='text'] {
    width: 90%;
    height: 30px;
    border-radius: 3px;
    padding-left: 8px;
    border: 1px solid #d7d8d9;
}

.new-main table td .other-plan {
    margin-left: 13px;
}

.new-main table td .title-tip {
    position: absolute;
}

.remark_r {
    color: #F00;
}

.new-main table .v-top {
    vertical-align: top;
    text-align: right;
}

.new-main table td .mar-top16 {
    margin-top: 16px;
}

.new-main table .v-top span {
    display: inline-block;
}

.new-main table td .plan-content-wrap {
    border: 1px solid transparent;
}

.new-main table td .plan-content {
    position: relative;
    width: 90%;
    padding: 9px;
    background-color: #f8f8f8;
    margin-bottom: 24px;
    transition: border-color .3s;
    border: 1px solid transparent;
    margin-right: 20px;
}

.new-main table td .plan-content input[type='text'] {
    width: 90%;
}

.new-main table td .content-tip {
    line-height: 24px;
    height: 16px;
}

.new-main table td .plan-content .plan-detail-box {
    padding: 0;
    margin: -20px 0;
}

.new-main table td .plan-content .plan-detail {
    position: relative;
    overflow: hidden;
}

.new-main table td .plan-content textarea {
    resize: none;
    width: 40%;
    min-height: 60px;
    padding-right: 20px;
    border-radius: 0;
    border: 1px solid #d7d8d9;
    margin-bottom: 16px;
    overflow: hidden;
}

.icon-remove {
    position: relative;
    top: 10px;
    left: 10px;
    font-size: 14px;
}

.new-main table td .remove {
    font-size: 18px;
    position: relative;
    text-shadow: none;
    top: 1px;
    margin-left: 1px;
    margin-right: 16px;
    color: #a7bdcd;
    font-style: normal;
    font-family: "Font Awesome 5 Pro";
    font-weight: 900;
}

.new-main table td .sec-remove {
    position: absolute;
    top: 2px;
    right: 10px;
    background-color: transparent;
    margin: 0;
}

.new-main table td .plan-content .add-detail {
    cursor: pointer;
    margin-left: 20px;
    margin-top: 15px;
}

.icon-add-detail {
    font-style: normal;
    width: 9px;
    height: 9px;
    color: #2299ee;
    background-position: -87px -36px;
}


.new-main table td .plan-content i {
    cursor: pointer;
}

.new-main table td .plan-content .add-detail i {
    vertical-align: 0px;
    margin-right: 4px;
}

.text-blue {
    color: #2299ee;
}

.text-gray {
    color: #ccc;
}

.add-detail span {
    margin-right: 10px;
}

.add-category {
    height: 40px;
    line-height: 40px;
    text-align: center;
    background-color: #f8f8f8;
    color: #2299ee;
    cursor: pointer;
    width: 700px;
}

.icon-add-category {
    font-style: normal;
    background-position: -32px -32px;
    width: 18px;
    height: 18px;
}

.new-main table td .add-category i {
    vertical-align: middle \0;
    margin-right: 8px;
}

.new-main table .v-top {
    vertical-align: top;
    text-align: right;
}

.padding-top-a8 {
    padding-top: 8px;
}

.new-main table td .plan-conclusion {
    width: 689px;
    resize: none;
    border-radius: initial;
}

.btn-group {
    position: relative;
    display: inline-block;
    *display: inline;
    *zoom: 1;
    vertical-align: middle;
    white-space: nowrap;
    *margin-left: .3em;
}

.btn-group button {
    height: 30px;
    margin-right: 10px;
    border-style: none;
    font-size: 12px;
    border-radius: 3px
}

.btn-group button.release {
    width: 120px;
    background-color: #2299ee;
    color: #fff;
}

.btn-group button.cancel {
    width: 90px;
    background-color: #fff;
    border: 1px solid #d7d8d9;
    color: #000;
}

.mask-span {
    width: 120px;
    display: inline-block;

    height: 26px;
    padding: 0 0;
    line-height: 26px;
    padding-left: 10px;
    background-color: transparent;
    border: 1px solid #d7d8d9;
    border-radius: 0;
    color: #666;
    cursor: pointer;
    margin-right: 10px;
    margin-left: 0;
    position: relative;
    z-index: 19;
}

.mask-span.week {
    width: 160px;
}

#week-plan, #month-plan, #quarter-plan {
    line-height: 24px;
    display: inline-block;
    vertical-align: middle;
}

.icon-triangle-up, .icon-triangle-right, .icon-triangle-down, .icon-triangle-left {
    background-image: none;
    width: 0;
    height: 0;
    cursor: pointer;
}

.icon-triangle-down {
    border-left: 5px solid transparent;
    border-top: 5px solid #9a9a9a;
    border-right: 5px solid transparent;
    vertical-align: middle;
    display: inline-block;
}

* {
    margin: 0;
    padding: 0;
    list-style: none;

}

.head {
    padding: 20px;
}

.navBar input {
    width: 215px;
    height: 38px;
    display: inline-block;
}

.show1 {
    width: 320px;
    margin-top: 5px;
    position: absolute;
    z-index: 2;

    height: 160px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
    background: #fff;
    padding: 5px;
}

.show1 p:nth-child(1) {
    width: 100%;
    height: 40px;
    border-bottom: 1px solid #f5f5f5;
}

.show1 p:nth-child(2) {
    box-sizing: border-box;
}

.selectMonth {
    display: inline-block;
    float: left;
    width: 78px;
    height: 40px;
    line-height: 40px;
    text-align: center;
}

.selectMonth:hover {
    background: rgba(19, 131, 255, 0.052);
}

.span-year {
    width: 90%;
    margin: 0 auto;
    display: inline-block;
    text-align: center;
    line-height: 40px;

}

.el-input {
    width: 215px;
    height: 45px;
    display: inline-block;
}

.new-main table td .other-plan {
    margin-left: 13px;
    font-size: 12px;
}

.new-main table td .other-plan a.look-prev {
    border-right: 1px solid #d9d9d9;
    display: inline-block;
    line-height: 12px;
    padding-right: 8px;
    margin-right: 7px;
}

.new-main table td .other-plan a {
    color: #29e;
}

.mainright {
    margin-right: 522px
}

</style>
<style>
.el-select .el-input__inner {
    font-size: 11px !important;
}

.el-select-dropdown__item {
    text-align: center;
}

.detailDate .el-input__icon {
    height: 28px;
    line-height: 28px;
}

.detail-end-Date .el-input__icon {
    display: none;
}

.detail-end-Date .el-input__inner {
    margin-left: 0 !important;
    width: 40px !important;
}

.detailDate .el-input__inner {
    height: 28px;
    line-height: 28px;
    width: 80px;
    font-size: 12px;
    padding-right: 0px !important;
    margin-left: 8px;
}

.detailDate.el-input {
    height: 28px;
    line-height: 28px;
}

#custom-plan .el-input--suffix .el-input__inner {
    padding-right: 0 !important;
}

.plan-detail .el-input--suffix .el-input__inner {
    padding-right: 0 !important;
    padding-left: 0 !important;
}

.el-date-editor--daterange.el-input__inner {
    width: 200px !important;
}

.el-date-editor .el-range-input {
    width: 22% !important;
    font-size: 12px !important;
}

.el-date-editor .el-range-separator {
    width: 11% !important;
}

.el-input__inner {
    border: none;
    text-align: center;
}
</style>